var _LogoBrands$DoorDash, _LogoBrands$Caviar, _DefaultLogoSizes, _DefaultColors, _TextColorMap;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Colors } from '@doordash/design-language';
import PropTypes from 'prop-types';
export var LogoBrands = {
  Caviar: 'BRAND_CAVIAR',
  DoorDash: 'BRAND_DOORDASH'
};
export var LogoTypes = {
  Logo: 'LOGO',
  LogoMark: 'LOGO_MARK'
};
export var LogoSizes = {
  Small: 'LOGO_SIZES/SMALL',
  Base: 'LOGO_SIZES/BASE',
  Large: 'LOGO_SIZES/LARGE',
  Huge: 'LOGO_SIZES/HUGE'
};
export var DefaultLogoSizes = (_DefaultLogoSizes = {}, _defineProperty(_DefaultLogoSizes, LogoBrands.DoorDash, (_LogoBrands$DoorDash = {}, _defineProperty(_LogoBrands$DoorDash, LogoSizes.Small, 16), _defineProperty(_LogoBrands$DoorDash, LogoSizes.Base, 18), _defineProperty(_LogoBrands$DoorDash, LogoSizes.Large, 24), _defineProperty(_LogoBrands$DoorDash, LogoSizes.Huge, 32), _LogoBrands$DoorDash)), _defineProperty(_DefaultLogoSizes, LogoBrands.Caviar, (_LogoBrands$Caviar = {}, _defineProperty(_LogoBrands$Caviar, LogoSizes.Small, 20), _defineProperty(_LogoBrands$Caviar, LogoSizes.Base, 24), _defineProperty(_LogoBrands$Caviar, LogoSizes.Large, 28), _defineProperty(_LogoBrands$Caviar, LogoSizes.Huge, 32), _LogoBrands$Caviar)), _DefaultLogoSizes);
var CAVIAR_COLOR = '#F97242';
export var DefaultColors = (_DefaultColors = {}, _defineProperty(_DefaultColors, LogoBrands.DoorDash, Colors.BrandRedBase), _defineProperty(_DefaultColors, LogoBrands.Caviar, CAVIAR_COLOR), _DefaultColors);
export var LogoColors = {
  Default: 'DEFAULT',
  Black: Colors.SystemBlack,
  White: Colors.SystemWhite
};
export var TextColorMap = (_TextColorMap = {}, _defineProperty(_TextColorMap, DefaultColors[LogoBrands.DoorDash], Colors.SystemBlack), _defineProperty(_TextColorMap, DefaultColors[LogoBrands.Caviar], Colors.TextTertiary), _defineProperty(_TextColorMap, LogoColors.Black, Colors.SystemBlack), _defineProperty(_TextColorMap, LogoColors.White, Colors.SystemWhite), _TextColorMap);
export var PROP_TYPES = {
  color: PropTypes.string,
  size: PropTypes.number
};
export var DEFAULT_PROPS = {
  color: LogoColors.Red,
  size: LogoSizes.Base
}; // Each part of the Logo needs to have
// the correct sizing and proporations
// relative to each other. We encode
// the ratios between parts here.
// LogoText

export var DD_ORIGINAL_TEXT_HEIGHT = 42.0;
export var DD_ORIGINAL_TEXT_WIDTH = 361.1;
export var DD_TEXT_ASPECT_RATIO = DD_ORIGINAL_TEXT_WIDTH / DD_ORIGINAL_TEXT_HEIGHT;
export var CV_ORIGINAL_TEXT_HEIGHT = 108;
export var CV_ORIGINAL_TEXT_WIDTH = 430;
export var CV_TEXT_ASPECT_RATIO = CV_ORIGINAL_TEXT_WIDTH / CV_ORIGINAL_TEXT_HEIGHT; // LogoMark

export var DD_ORIGINAL_MARK_WIDTH = 99.5;
export var DD_ORIGINAL_MARK_HEIGHT = 56.5;
export var DD_MARK_ASPECT_RATIO = DD_ORIGINAL_MARK_WIDTH / DD_ORIGINAL_MARK_HEIGHT;
export var CV_ORIGINAL_MARK_WIDTH = 60;
export var CV_ORIGINAL_MARK_HEIGHT = 70;
export var CV_MARK_ASPECT_RATIO = CV_ORIGINAL_MARK_WIDTH / CV_ORIGINAL_MARK_HEIGHT; // Ratio between LogoMark and LogoText

export var DD_MARK_TEXT_RATIO = DD_ORIGINAL_MARK_HEIGHT / DD_ORIGINAL_TEXT_HEIGHT;
export var CV_MARK_TEXT_RATIO = 1; // Size between LogoMark => LogoText => Additional text

var DD_ORIGINAL_SPACER = 41;
export var DD_SPACER_RATIO = DD_ORIGINAL_SPACER / DD_ORIGINAL_MARK_HEIGHT;
var CV_ORIGINAL_SPACER = 41;
export var CV_SPACER_RATIO = CV_ORIGINAL_SPACER / CV_ORIGINAL_MARK_HEIGHT; // Size helpers

export var textHeightForSize = function textHeightForSize(size, brand) {
  switch (brand) {
    case LogoBrands.Caviar:
      return Math.round(size / CV_MARK_TEXT_RATIO);

    case LogoBrands.DoorDash:
    default:
      return Math.round(size / DD_MARK_TEXT_RATIO);
  }
};
export var textWidthForSize = function textWidthForSize(size, brand) {
  switch (brand) {
    case LogoBrands.Caviar:
      return Math.round(textHeightForSize(size, brand) * CV_TEXT_ASPECT_RATIO);

    case LogoBrands.DoorDash:
    default:
      return Math.round(textHeightForSize(size, brand) * DD_TEXT_ASPECT_RATIO);
  }
};
export var markWidthForSize = function markWidthForSize(size, brand) {
  switch (brand) {
    case LogoBrands.Caviar:
      return Math.round(size * CV_MARK_ASPECT_RATIO);

    case LogoBrands.DoorDash:
    default:
      return Math.round(size * DD_MARK_ASPECT_RATIO);
  }
};
export var spacerForSize = function spacerForSize(size, brand) {
  switch (brand) {
    case LogoBrands.Caviar:
      return Math.round(size * CV_SPACER_RATIO);

    case LogoBrands.DoorDash:
    default:
      return Math.round(size * DD_SPACER_RATIO);
  }
};